// https://github.com/mozilla/pdf.js/wiki/Setup-pdf.js-in-a-website
// https://github.com/mozilla/pdf.js/tree/master/examples/webpack#worker-loading
import * as pdfjsLib from "pdfjs-dist";
import * as PDFJSViewerLib from "pdfjs-dist/web/pdf_viewer.js";
import { environment } from "src/environments/environment";
export default class PDFViewer {
  assets = environment.assetUrl;
  USE_ONLY_CSS_ZOOM = false;
  CMAP_URL = "";
  CMAP_PACKED = true;
  DEFAULT_SCALE_DELTA = 1.1;
  MAX_SCALE = 10.0;
  MIN_SCALE = 0.25;
  pdfViewer;
  pdfLinkService;
  eventBus;
  pdfDocument;
  onSuccess: Function; // on successful loading of PDF
  onError: Function; // on failure to load PDF

  constructor(container, fileUrl, successCallback, errorCallback) {
    this.onSuccess = successCallback;
    this.onError = errorCallback;
    pdfjsLib.GlobalWorkerOptions.workerSrc = `${this.assets}/pdfjs-dist/pdf.worker.js`;
    this.CMAP_URL = `${this.assets}/pdfjs-dist/cmaps/`;
    // (Optionally) enable hyperlinks within PDF files.

    this.eventBus = new PDFJSViewerLib.EventBus();
    const pdfLinkService = new PDFJSViewerLib.PDFLinkService({
      eventBus: this.eventBus,
    });
    // (Optionally) enable find controller.
    const pdfFindController = new PDFJSViewerLib.PDFFindController({
      linkService: pdfLinkService,
      eventBus: this.eventBus,
    });
    this.pdfViewer = new PDFJSViewerLib.PDFViewer({
      container: container,
      linkService: pdfLinkService,
      findController: pdfFindController,
      useOnlyCssZoom: this.USE_ONLY_CSS_ZOOM,
      eventBus: this.eventBus,
    });

    pdfLinkService.setViewer(this.pdfViewer);
    this.pdfLinkService = pdfLinkService;

    this.eventBus.on("pagesinit", () => {
      this.pdfViewer.firstPagePromise.then(() => {
        this.pdfViewer.currentScaleValue = "auto";
      });
    });
    this.open({
      url: fileUrl,
    });
    return this;
  }

  getDocument(fileUrl) {
    return pdfjsLib.getDocument(fileUrl);
  }
  open(params) {
    const loadingTask = pdfjsLib.getDocument({
      url: params.url,
      cMapUrl: this.CMAP_URL,
      cMapPacked: this.CMAP_PACKED,
    });
    loadingTask.promise.then(
      (pdfDocument) => {
        // Document loaded, specifying document for the viewer.
        this.pdfDocument = pdfDocument;
        this.pdfViewer.setDocument(pdfDocument);
        this.pdfLinkService.setDocument(pdfDocument, null);
        this.onSuccess();
      },
      (error) => {
        this.onError();
        throw new Error(error.message);
      },
    );
  }
  zoomIn() {
    let newScale = this.pdfViewer.currentScale;
    newScale = (newScale * this.DEFAULT_SCALE_DELTA).toFixed(2);
    newScale = Math.ceil(newScale * 10) / 10;
    newScale = Math.min(this.MAX_SCALE, newScale);
    this.pdfViewer.currentScaleValue = newScale;
  }
  zoomOut() {
    let newScale = this.pdfViewer.currentScale;
    newScale = (newScale / this.DEFAULT_SCALE_DELTA).toFixed(2);
    newScale = Math.floor(newScale * 10) / 10;
    newScale = Math.max(this.MIN_SCALE, newScale);
    this.pdfViewer.currentScaleValue = newScale;
  }

  // should be called when right panel is closed or opened
  resetPages() {
    this.pdfViewer.currentScaleValue = "auto";
    // this.pdfViewer.DEFAULT_SCALE_VALUE = 'page-width';
    for (let page = 0; page < this.pdfViewer.pagesCount; page++) {
      const pageCanvas = this.pdfViewer.getPageView(page);
      pageCanvas.div.style.margin = "auto";
      this.pdfViewer.getPageView(page).reset();
    }
    this.pdfViewer.update();
  }
}
